module.exports = __webpack_public_path__ + "static/media/29ADMSPC14.89362b1b.jpg";